import { ArrayUtil } from 'src/utils';
import ContactListItemDTO from './ContactListItemDTO';
import LocationListItemDTO from './LocationListItemDTO';
import LocationAccessListItemDTO from './LocationAccessListItemDTO';
import AccountingLinkUserLoginListItemDTO from './AccountingLinkUserLoginListItemDTO';
import HelpDeskUserLoginListItemDTO from './HelpDeskUserLoginListItemDTO';
import AssetListItemDTO from './AssetListItemDTO';
import LicenseListItemDTO from './LicenseListItemDTO';
import ContractListItemDTO from './ContractListItemDTO';
import CaseListItemDTO from './CaseListItemDTO';
import RegistrationListItemDTO from './RegistrationListItemDTO';

interface CRMLookupDTO {
  accountNumber: string;
  accountPOS: string;
  accountName: string;
  accountPhone: string;
  accountAddress: string;
  accountAppEnabled: boolean;
  contactList: ContactListItemDTO[];
  locationList: LocationListItemDTO[];
  locationAccessList: LocationAccessListItemDTO[];
  accountingLinkUserLoginList: AccountingLinkUserLoginListItemDTO[];
  helpDeskUserLoginList: HelpDeskUserLoginListItemDTO[];
  assetList: AssetListItemDTO[];
  licenseList: LicenseListItemDTO[];
  contractList: ContractListItemDTO[];
  caseList: CaseListItemDTO[];
  registrationList: RegistrationListItemDTO[];
}
const CRMLookupDTO = {
  create: (initValues?: Partial<CRMLookupDTO>): CRMLookupDTO => {
    const defaults: CRMLookupDTO = {
      accountNumber: '',
      accountPOS: '',
      accountName: '',
      accountPhone: '',
      accountAddress: '',
      accountAppEnabled: false,
      contactList: [],
      locationList: [],
      locationAccessList: [],
      accountingLinkUserLoginList: [],
      helpDeskUserLoginList: [],
      assetList: [],
      licenseList: [],
      contractList: [],
      caseList: [],
      registrationList: [],
    };
    const fixedInitValues: Partial<CRMLookupDTO> = initValues != null
      ? {
        contactList: ArrayUtil.EasyMap(initValues.contactList, ContactListItemDTO.create),
        locationList: ArrayUtil.EasyMap(initValues.locationList, LocationListItemDTO.create),
        locationAccessList: ArrayUtil.EasyMap(initValues.locationAccessList, LocationAccessListItemDTO.create),
        accountingLinkUserLoginList: ArrayUtil.EasyMap(initValues.accountingLinkUserLoginList, AccountingLinkUserLoginListItemDTO.create),
        helpDeskUserLoginList: ArrayUtil.EasyMap(initValues.helpDeskUserLoginList, HelpDeskUserLoginListItemDTO.create),
        assetList: ArrayUtil.EasyMap(initValues.assetList, AssetListItemDTO.create),
        licenseList: ArrayUtil.EasyMap(initValues.licenseList, LicenseListItemDTO.create),
        contractList: ArrayUtil.EasyMap(initValues.contractList, ContractListItemDTO.create),
        caseList: ArrayUtil.EasyMap(initValues.caseList, CaseListItemDTO.create),
        registrationList: ArrayUtil.EasyMap(initValues.registrationList, RegistrationListItemDTO.create),
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default CRMLookupDTO;
